<template>
    <div class="lp-featured-blog-posts">
        <a class="lp-featured-blog-post"
           v-for="(post, postIndex) in posts"
           :key="`featured-post-${postIndex}`"
           :href="post.Url ? post.Url : '#'">
            <div class="featured-blog-post__number">{{ postIndex + 1 }}</div>
            <div class="featured-blog-post__content">
                <p class="featured-blog-post__title">
                    {{ post.Title }}
                </p>
                <!-- <p>{{ post.PublicationDate }}</p> -->
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'BlogFeaturedPosts',
        props: {
            posts: {
                type: Array,
                required: true,
            },
        },
        setup() { },
    };
</script>

<style lang="scss" scoped></style>